export enum CustomHeaders {
  TotalCount = 'egose-total-count',
}
